/**
 * author: Ananthapadmanabhan V K
 */
import React from 'react';
import PropTypes from 'prop-types';
import './Dashboard.scss';
import { withTranslation } from 'react-i18next';
import { BiPlus, BiShareAlt } from "react-icons/bi";
import { Badge, Table } from 'react-bootstrap';
import Map from '../../../images/world-map.gif'
import { Chart } from "react-google-charts";
import CompanyDashboard from '../CompanyDashboard/CompanyDashboard';
import SupplierDashboard from '../SupplierDashboard/SupplierDashboard';
import { USER_ROLE } from '../../../core/constants/common';
import useHasPermission from '../../../core/hooks/useHasPermission';

export const data = [
  ["Country", "Risk"],
  ["Germany", 200],
  ["United States", 300],
  ["Brazil", 400],
  ["Canada", 500],
  ["France", 600],
  ["RU", 700],
];

export const options = {
  // region: "002",
  colorAxis: { colors: ["#0a58ca", "#dddddd", "#0a58ca"] },
  backgroundColor: "#ffffff",
  datalessRegionColor: "#0a58ca",
  defaultColor: "#0a58ca",
};

const Dashboard = ({ t }) => {
  const { hasDashboardViewPermission } = useHasPermission();
  var isCompanyAdmin = true;
  var lsDat = JSON.parse(localStorage.getItem('authority'));
  if (hasDashboardViewPermission()) {
    isCompanyAdmin = true;
  } else {
    isCompanyAdmin = false;
  }
  return (
    <div className="Dashboard">
      {isCompanyAdmin
        ? <CompanyDashboard></CompanyDashboard>
        : <SupplierDashboard></SupplierDashboard>}
    </div>
  );
};
export default withTranslation()(Dashboard);

